import React from 'react';
import { LandingLayout } from 'components/Landing/LandingLayout';
import { observer } from 'mobx-react';
import { withErrorBoundary } from 'react-error-boundary';
import { handleError } from 'services/ErrorService';
import ComponentError from 'components/Error/ComponentError';
import { useTranslation } from 'react-i18next';

interface PrerequisitesProps {
  prerequisites?: string[];
}

const Prerequisites: React.FC<PrerequisitesProps> = ({ prerequisites }) => {
  const { t } = useTranslation();

  if (!prerequisites || !prerequisites.length) {
    return null;
  }

  return (
    <>
      <LandingLayout.ContentHeading>
        {t('Prerequisites')}
      </LandingLayout.ContentHeading>
      <LandingLayout.List>
        {prerequisites.map((prerequisite) => (
          <li key={prerequisite}>{prerequisite}</li>
        ))}
      </LandingLayout.List>
    </>
  );
};

export default withErrorBoundary(
  observer(Prerequisites),
  ComponentError,
  handleError,
);
